import { ActionButton, WithActionBar } from "@/src/components/wrappers/WithActionBar";
import { EditYachtForm } from "./EditYacht/EditYachtForm";
import { ChevronLeftIcon, ChevronRightIcon, PlusIcon } from "lucide-react";
import { Content } from "@/src/components/wrappers/Content";
import { useStepsStore } from "./EditYacht/state";
import { Button } from "@/src/components/ui/button";
import { Steps } from "@/src/components/ui/steps";
import { serializeYachtForm, YachtForm } from "./EditYacht/yacht.schema";
import { useFetch } from "@/src/lib/useFetch";
import { useToast } from "@/src/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export function AddYacht() {
  const steps = useStepsStore();
  const { fetch, isFetching } = useFetch();
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    steps.setStep("Basic details");
  }, []);

  const onSubmit = async (data: YachtForm) => {
    if (!isFetching) {
      try {
        const payload = serializeYachtForm(data);
        await fetch("/api/yachts/yachts", "POST", payload);
        toast({
          title: "Yacht change",
          description: "The yacht has been saved",
          variant: "default",
        });
        navigate(`/yachts`);
      } catch (e: any) {
        console.error(e);
        toast({
          title: "Failed to save yacht",
          description: e.message || "An error occurred while saving the yacht",
          variant: "destructive",
        });
      }
    }
  };

  return (
    <WithActionBar actionBar={<ActionBar />}>
      <Content title="Add a non-API yacht">
        <Steps onStepChange={steps.setStep} step={steps.step} items={steps.allSteps} className="mb-6" />
        <EditYachtForm onSubmit={onSubmit} />
      </Content>
    </WithActionBar>
  );
}

function ActionBar() {
  const steps = useStepsStore();
  return (
    <div className="flex justify-between items-center">
      <Button onClick={steps.previousStep} disabled={steps.isFirstStep} variant="outline">
        <ChevronLeftIcon size={16} />
        Back
      </Button>
      <div className="flex items-center gap-4">
        <ActionButton variant="secondary" eventKey="yacht:save">
          Save
        </ActionButton>
        {!steps.isLastStep && (
          <Button onClick={steps.nextStep}>
            Next <ChevronRightIcon size={16} />
          </Button>
        )}
      </div>
    </div>
  );
}
